<template>
<div style="width: 100%">
	<v-tooltip top slot="activator">
		<v-btn
			slot="activator"
			color="indigo lighten-3"
			dark
			fab
			@click="addPay"
			v-if="editable"
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('personal_finance.add_output_button')}}</span>
	</v-tooltip>
	<v-tooltip top slot="activator">
		<v-btn
			slot="activator"
			color="indigo lighten-2"
			dark
			fab
			@click="openTransferDialog"
			v-if="editable && hasRole('admin')"
		>
			<v-icon>attach_money</v-icon>
		</v-btn>
		<span>{{$t('personal_finance.transfer_button')}}</span>
	</v-tooltip>
	<v-card style="width: 100%">
		<v-data-table
			:headers="headers"
			:items="outputFinances"
			hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.amount }}</td>
				<td>{{ props.item.comment }}</td>
				<td>{{ props.item.category }}</td>
				<td>{{ props.item.created_at }}</td>
				<td v-if="hasRole('admin')">
					{{ props.item.transaction ? props.item.transaction.recipient_user.name: null }}
				</td>
				<td class="text-xs-center" v-if="editable && props.item.editable">
					<div class="button-group">
						<v-btn fab dark small
							color="indigo lighten-2"
							@click="editPay(props.item)"
						>
							<v-icon dark>edit</v-icon>
						</v-btn>
						<ConfirmDialog class="delete-confirm"
							v-bind="propConfirmDialog"
							@accept="onDeletePay(props.item)"
							:tooltip="$t('common.delete')"
						>
							<v-icon dark>delete</v-icon>
						</ConfirmDialog>
					</div>
				</td>
			</template>
		</v-data-table>
	</v-card>
	<finance-dialog
		v-model="dialog"
		:editablePay="editablePay"
		:transferPay="transferPay"
		v-if="editable"
	/>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { HEADERS_TABLE_PERSONAL_FINANCE } from '../../constants'
import { localeHeadersPersonalFinances } from "../../utils/helpers";
import FinanceDialog from './FinanceDialog'
import ConfirmDialog from '../../components/ConfirmDialog'
import { notify } from '../../utils/notifications'

export default {
	components: {
		FinanceDialog,
		ConfirmDialog
	},
	props: {
		editable: {
			type: Boolean,
			default: true
		}
	},
	data: (vm) => ({
		dialog: false,
		editablePay: null,
		transferPay: false,
		propConfirmDialog: {
			message: vm.$t('personal_finance.confirm_message_pay'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		}
	}),
	computed: {
		...mapGetters({
			outputFinances: 'finance/getOutputFinance',
			hasRole: 'auth/hasRole'
		}),
		headers() {
			let headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
			if(!this.editable) {
				headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
					.filter((item,index) => {
						return item.value != 'actions'
					})
			}
			if(!this.hasRole('admin')) {
				headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
					.filter((item,index) => {
						return item.value != 'transfer_user_name'
					})
			}
			return headers;
		}
	},
	methods: {
		...mapActions({
			deletePay: 'finance/deletePay',
			deleteTransferPay: 'finance/deleteTransferPay',
			fetchUsers: 'users/fetch'
		}),
		addPay() {
			this.dialog = true
			this.editablePay = null
			this.transferPay = false
		},
		openTransferDialog() {
			this.dialog = true
			this.editablePay = null
			this.transferPay = true
			this.fetchUsers({
				count: 100
			})
		},
		editPay(pay) {
			this.dialog = true
			this.editablePay = pay
			this.transferPay = false
		},
		onDeletePay(pay) {
			if(pay.transaction) {
				this.deleteTransferPay(pay.transaction_id)
					.then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.deleted', { type: this.$t('personal_finance.transfer') }),
						})
					})
			} else {
				this.deletePay(pay.id)
					.then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.deleted', { type: this.$t('personal_finance.finance') }),
						})
					})
			}
		}
	}
}
</script>

<style>
.button-group {
	display: inline-block;
}
</style>
